const FormType = {
    LOGIN: "LOGIN",
    REGISTER: "REGISTER"
}

export default FormType;